"use strict";
import { jsx } from "react/jsx-runtime";
const possibleNonCalculatedAlertIcon = (fromAdjustmentPriceSheet, ignoreAdjustmentLineItems, isMany) => {
  if (ignoreAdjustmentLineItems && fromAdjustmentPriceSheet) {
    return /* @__PURE__ */ jsx("span", { className: "load-detail__adjustments-icon", children: /* @__PURE__ */ jsx("i", { className: "fi-alert", children: nonCalculatedAlertMessage(isMany) }) });
  }
};
const nonCalculatedAlertMessage = (isMany) => {
  let message = "This item was imported as an adjustment and is not included\nin payment or expected amount calculations.";
  if (isMany) {
    message = "Some items were imported as adjustments and are not included\nin payment or expected amount calculations.";
  }
  return /* @__PURE__ */ jsx("span", { className: "load-detail__adjustments-message", children: message });
};
export default possibleNonCalculatedAlertIcon;
